export const CHAT_SESSION_TABLE = "chatSessions"
export const CHAT_SESSION_TABLE_SCHEMA =
  "id, companyId, userId, syncId, updatedAt"
